import React, { useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Hidden from "@material-ui/core/Hidden";

const useStyle = makeStyles({
  jumbotron: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 0
  },
  barraAzul: {
    backgroundImage: 'linear-gradient(278deg, #061f80, #0430ad)',
    width: '100%',
    minHeight: 160,
    position: 'absolute',
  },
  barraAzulEditar: {
    backgroundImage: 'linear-gradient(278deg, #061f80, #0430ad)',
    width: '100%',
    height: 160,
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center'
  },
  tituloPagina: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 49,
    fontWeight: 500,
    color: 'white',
    margin: 20,
  },
  subTituloPagina: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 24,
    fontWeight: 500,
    color: 'white',
    margin: 20,
  },
  quadradoEscuro: {
    width: 36,
    height: 36,
    backgroundColor: '#0430ad',
    position: 'absolute',
    right: 0,
    top: 0,
  },
  quadradoClaro: {
    width: 36,
    height: 36,
    backgroundColor: '#044ada',
    position: 'absolute',
    right: 36,
    top: 36,
  },
  actionButton: {
    position: 'absolute',
    right: 24,
    top: 40,
    zIndex: 10
  }
})


const FormHeader = (props) => {
  const classes = useStyle();
  const { titulo, subTitulo, isEditar, ActionButton } = props;

  useEffect(() => {
    console.log(ActionButton, 'action button')
  },[ActionButton]);
  return (
    <div className={classes.jumbotron}>
      <div className={isEditar ? classes.barraAzulEditar : classes.barraAzul}>
        <div style={{ zIndex: 2 }}>
          <p className={classes.tituloPagina}>{titulo}</p>
          {subTitulo && <p className={classes.subTituloPagina}>{subTitulo}</p>}
        </div>
        {ActionButton && 
        <div className={classes.actionButton}>
          {ActionButton?.()}
        </div>
        }
      </div>
      <Hidden xsDown>
        <>
          <div className={classes.quadradoClaro} />
          <div className={classes.quadradoEscuro} />
        </>
      </Hidden>
    </div>
  )
};

export default FormHeader;
